export enum MainRoutes {
  ROOT = '',
  AUTH = 'auth',
  ORDER = 'order',
  SCORING = 'scoring',
  AGREEMENTS = 'agreements',
  CONDITIONS = 'conditions',
  PAYMENTS = 'payments',
  STATUS = 'status',
  OAUTH = 'oauth2',
  PROFILE = 'userProfile',
  DOCUMENTS = 'documents',
  SHOW_IFRAME = 'show-iframe',
  ERROR = 'error',
  UNKNOWN = '**',
}
